import styled from 'styled-components'
import { HierarchyCard } from '@yes.technology/react-toolkit'

export const Card = styled(HierarchyCard)`
  > div {
    padding: 0px;
  }
`

export const TitleWrapper = styled.div`
  padding: 8px;
  padding-bottom: 16px;
`

export const ContentWrapper = styled.div`
  padding: 8px;
  padding-top: 16px;
`
